export class OutsourceListMode {
    static GRID = 'grid';
    static LIST = 'list';
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/outsource/list/OutsourceListMode.js